import { jsx as C } from "react/jsx-runtime";
import { createContext as E, useMemo as y, useContext as O, useRef as A, useCallback as _, useEffect as x } from "react";
const m = {
  enabled: !1,
  sampleRate: 1
}, M = E(m), h = 20, v = 80, D = (t) => {
  if (!t)
    return;
  const e = Object.entries(t).slice(0, h), r = {};
  return e.forEach(([c, n]) => {
    if (typeof n == "string") {
      r[c] = n.slice(0, v);
      return;
    }
    (typeof n == "number" || typeof n == "boolean") && (r[c] = n);
  }), Object.keys(r).length > 0 ? r : void 0;
}, I = (t) => t === void 0 ? !0 : t <= 0 ? !1 : t >= 1 ? !0 : Math.random() < t, w = ({ config: t, children: e }) => {
  const r = y(
    () => ({
      ...m,
      ...t
    }),
    [t]
  );
  return /* @__PURE__ */ C(M.Provider, { value: r, children: e });
}, G = (t, e) => {
  const { enabled: r, track: c, sampleRate: n, allowlist: u, redact: s } = O(M), l = A(!1), T = A(e == null ? void 0 : e.metadata), f = (e == null ? void 0 : e.trackOnMount) ?? !0, b = !u || u.includes(t), o = r && !!c && b, a = _(
    (i, k) => {
      if (!o || !c || !I(n))
        return;
      const d = {
        component: t,
        event: i,
        timestamp: Date.now(),
        metadata: D(k)
      };
      c(s ? s(d) : d);
    },
    [o, t, s, n, c]
  );
  return x(() => {
    !f || l.current || (l.current = !0, a("render", T.current));
  }, [a, f]), {
    enabled: o,
    track: a,
    trackInteraction: (i) => a("interaction", i)
  };
};
export {
  w as C,
  G as u
};
